
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs",
      function () {
        return require("private-next-pages/docs/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs"])
      });
    }
  